























import Glide from '@glidejs/glide';

import {
  Component,
  Vue,
} from 'vue-property-decorator';

const CarouselProps = Vue.extend({
  props: {
    perView: {
      type: Number,
      default: 1,
    },
    gap: {
      type: Number,
      default: 0,
    },
    bullet: {
      type: Boolean,
      default: true,
    },
    rewind: {
      type: Boolean,
      default: false,
    },
  },
});

@Component
export default class Carousel extends CarouselProps {
  private static readonly DefaultClasses = {
    direction: {
      ltr: 'glide-ltr',
      rtl: 'glide-rtl',
    },
    slider: 'glide-slider',
    carousel: 'glide-carousel',
    swipeable: 'glide-swipeable',
    dragging: 'glide-dragging',
    cloneSlide: 'glide-slide-clone',
    activeNav: 'glide-bullet-active',
    activeSlide: 'glide-slide-active',
    disabledArrow: 'glide-arrow-disabled',
  };

  private glide: any = null;

  public mounted() {
    this.mountGlide();
  }

  public destroyed() {
    this.glide.destroy();
  }

  public updated() {
    this.glide.destroy();
    this.mountGlide();
  }

  private mountGlide() {
    this.glide = new Glide(this.$el, this.options);
    this.glide.mount();
  }

  get options() {
    return {
      perView: this.perView,
      gap: this.gap,
      bullet: this.bullet,
      rewind: this.rewind,
      classes: Carousel.DefaultClasses,
    };
  }

  get slidesCount() {
    return this.$slots.default.filter(
      (c) => (c.componentOptions && (c.componentOptions.tag === 'carousel-slide')),
    ).length;
  }
}

